import { times, uniq, chunk } from 'lodash'
import { addMonths, addDays, getDay, parse } from 'date-fns'

/**
 * 開始日から指定数ヶ月分の月初日を配列で返します
 */
export function getMonths(start = new Date(), count = 12) {
  const date = parse(start).setDate(1)
  return times(count, i => addMonths(date, i))
}

/**
 * 指定月のカレンダーに表示する42日分(月曜始まり)の日付(date)を配列で返します
 */
export function getCalendar(date = new Date()) {
  const newDate = parse(date)
  const year = newDate.getFullYear()
  const month = newDate.getMonth()
  const lastMonthDays = getDay(new Date(year, month, 0))
  const startDate = addDays(parse(date).setDate(1), -lastMonthDays) // 最初の週の月曜日
  const calendar = times(42, i => addDays(startDate, i))
  return chunk(calendar, 7) // 二次元配列で返す
}

/**
 * 指定された月の週・曜日の配列を返します
 *  @param target Date
 *  @param order (0=毎週...5=第5)
 *  @param day (0=日曜...6=土曜)
 */
export function getMonthDays(date = new Date(), { order, day }) {
  const month = date.getMonth()
  const days = []

  if (order === null || day === null) return days

  // 対象日を設定
  while (date.getDay() !== day) {
    date.setDate(date.getDate() + 1)
  }
  if (order === 0) {
    while (date.getMonth() === month) {
      days.push(parse(date))
      date.setDate(date.getDate() + 7)
    }
  } else {
    date.setDate(date.getDate() + (order - 1) * 7)
    if (date.getMonth() === month) days.push(parse(date))
  }
  return days
}

/**
 * 日付の配列を一意にして昇順に並べ替えます
 */
export function sortDate(days) {
  return uniq(days).sort((a, b) => parse(a).getTime() - parse(b).getTime())
}
